import React from "react";

export default function ProveEvaluationSummary({ metrics }) {
  if (!metrics || metrics.schema_version !== 1) return null;
  const level = { 0: "정보 확인 중", 4: "호(4단위)", 6: "소호(6단위)", 10: "세번(10단위)" }[metrics.reached_level] || "정보 확인 중";
  return <details style={{ padding: "12px 14px", fontSize: 12 }}>
    <summary>이번 판정의 진행 지표</summary>
    <p>도달 단계: {level} · 판정 완료: {metrics.completed ? "예" : "아니오"} · 현재 확인 질문: {metrics.pending_question_count}개</p>
    <p>기록된 조건: {metrics.traced_condition_count}개 · 원문 링크가 있는 조건: {metrics.source_linked_condition_count}개</p>
    <p>전체 법적 요건의 충족률이나 분류 정확도를 뜻하지 않습니다. 오확정률과 후보 포함률은 별도 정답 대조 후 측정합니다.</p>
  </details>;
}
